import { render, staticRenderFns } from "./ProductsTab.vue?vue&type=template&id=62dc4351&scoped=true"
import script from "./ProductsTab.vue?vue&type=script&lang=js"
export * from "./ProductsTab.vue?vue&type=script&lang=js"
import style0 from "./ProductsTab.vue?vue&type=style&index=0&id=62dc4351&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dc4351",
  null
  
)

export default component.exports